import type { Chord, ChordWindowAnalysis } from '@tunasong/music-lib'
import { analyzeWindow } from '@tunasong/music-lib'
import type { Scale } from '@tunasong/schemas'

/**
 * Compute window-level analysis for the chord row a chord block belongs to.
 *
 * Plain function — NO hooks inside, so the React Hooks lint rule (and the
 * React Compiler's hook ordering invariant) do not apply. Callers may invoke
 * it after early returns. The `use*` prefix would imply hook semantics and
 * was deliberately dropped; React Compiler memoizes call sites without it.
 *
 * `phraseBoundary` is passed by the caller: in v1 the chord plugin treats
 * the line element as the phrase boundary ("end of line" = phrase end).
 */
export const getChordWindowAnalysis = (
  chords: Chord[],
  scale: Scale | undefined,
  phraseBoundary: boolean
): ChordWindowAnalysis => analyzeWindow({ chords, scale, context: { phraseBoundary } })
